var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Provides the material selection step for swimming pool cover damage declaration, as image-based choices bound via v-model.
 * touches: external damage declaration flow, swimming pool cover panel configuration, image-based material selection UI.
 * invariants: selected materials are managed through v-model; available choices come from shared swimming pool cover material definitions using the same enum as the external damage payload.
 * inputs: v-model materials array, material choices, translation keys, images, external damage translation helpers.
 * outputs: emits updated selected materials via v-model to the parent SwimpoolCover component, renders translated choices with images.
 * see: SwimpoolCover.vue, SwimpoolCoverConstants
 */
import { Component, VModel } from 'vue-property-decorator';
import { UiCheckbox, UiCard } from '@claims-ia/design-system';
import { ExternalDamageComponent } from '@declaration/components/externalDamage/ExternalDamageComponent';
import { SWIMPOOL_COVER_PANELS_MATERIAL_CHOICES } from '@shared/constants/externalDamages/SwimpoolCoverConstants';
import { SWIMPOOL_COVER_PANELS_TITLE } from '@declaration/constants/externalDamages/SwimpoolCoverConstants';
let SwimpoolCoverPanelMaterials = class SwimpoolCoverPanelMaterials extends ExternalDamageComponent {
    get choices() {
        return SWIMPOOL_COVER_PANELS_MATERIAL_CHOICES.map((choice) => ({
            value: choice.value,
            label: this.$tc(choice.tradKey),
            imageSrc: choice.image,
        }));
    }
    get title() {
        return this.translateExternalDamageKey(SWIMPOOL_COVER_PANELS_TITLE);
    }
};
__decorate([
    VModel({ type: Array, default: () => [] })
], SwimpoolCoverPanelMaterials.prototype, "materials", void 0);
SwimpoolCoverPanelMaterials = __decorate([
    Component({ components: { UiCheckbox, UiCard } })
], SwimpoolCoverPanelMaterials);
export default SwimpoolCoverPanelMaterials;
